// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__4U7dq","pos":"Placeholder_pos__nM6Px","logo":"Placeholder_logo__2pjXi","desc":"Placeholder_desc__1yZkb"};